import { IDiagnostic } from 'interfaces'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledWrapper = styled.div`
  width: 100%;
  display: flex;
  div:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  div:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`
const StyledSection = styled.div<{ $bgColor?: string; $width?: string }>`
  background: ${({ $bgColor }) => $bgColor};
  width: ${({ $width }) => $width};
  height: 16px;
  position: relative;
  &:first-child {
    .diagnostic-node {
      display: none;
    }
  }
`
const StyledNode = styled.div`
  position: absolute;
  height: 16px;
  top: calc(100% + 4px);
  transform: translate(-50%);
`

const StyledCurrentPoint = styled.div<{
  $rank: IDiagnostic
  $value: number
  $lastChild: boolean
}>`
  position: absolute;
  height: 16px;
  bottom: calc(100% + 8px);
  transform: translate(-50%);
  white-space: nowrap;
  transform: translate(0%);
  font-weight: 700;
  z-index: 2;
  color: ${({ $rank }) => $rank.color};
  left: ${({ $rank, $value }) => {
    let percentValue: any =
      (($value - $rank.from) / ($rank.to - $rank.from)) * 100
    if (percentValue > 90) {
      percentValue = 90
    }
    return `${percentValue?.toFixed(2)}%`
  }};
`
const StyledDot = styled.span`
  position: absolute;
  width: 10px;
  height: 10px;
  background: white;
  bottom: -21px;
  background: radial-gradient(
    50% 50% at 50% 50%,
    #ffffff 0%,
    #ffffff 75%,
    rgba(255, 255, 255, 0.8) 100%
  );
  box-shadow: 0px 0px 2px rgba(85, 85, 85, 0.5);
  border-radius: 8px;
  z-index: 10;
`

const StyleDes = styled.span<{ $left: string }>`
  position: relative;
  left: -${({ $left }) => $left}%;
  span {
    margin-left: 4px;
  }
`

interface IProps {
  diagnostics?: Array<IDiagnostic>
  value?: number
}
const SliderDiagnostic = (props: IProps) => {
  const { diagnostics, value = 0 } = props
  const { t } = useTranslation()
  return (
    <StyledWrapper className="slider-diagnostic">
      {diagnostics?.map((rank, index) => {
        return (
          <StyledSection
            className="slider-diagnostic-section"
            key={rank.from}
            $bgColor={rank.color}
            $width={`${(100 / diagnostics?.length).toFixed(2)}%`}>
            {((value > rank.from && value < rank.to) ||
              (value > rank.to && index + 1 === diagnostics?.length)) && (
              <StyledCurrentPoint
                className="current-point"
                $rank={rank}
                $value={value}
                $lastChild={index === diagnostics?.length}>
                <StyledDot className="current-point-dot" />
                <StyleDes
                  $left={((100 * index) / diagnostics.length)?.toFixed(2)}>
                  {value}
                  <span>{t(rank.label)}</span>
                </StyleDes>
              </StyledCurrentPoint>
            )}
            <StyledNode className="diagnostic-node">{rank.from}</StyledNode>
          </StyledSection>
        )
      })}
    </StyledWrapper>
  )
}

export default SliderDiagnostic
